/**
 * Canonical business type values for seller company profile (dropdown in Business Information).
 * Use everywhere filters or forms must stay aligned (profile, seller directory, API).
 */
export const SELLER_BUSINESS_TYPE_OPTIONS = [
  "Manufacturer",
  "Exporter",
  "Trader",
  "Distributor",
  "Wholesaler",
  "Retailer",
  "Service Provider",
  "Other",
] as const;

export type SellerBusinessTypeOption =
  (typeof SELLER_BUSINESS_TYPE_OPTIONS)[number];
